import React from 'react';

const Loading = () => {
    return (
        <div class="h-screen bg-white">
            <div class="flex justify-center items-center h-full">
                <img className='w-12 h-12' src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif" alt='log' />
            </div>
        </div>
    );
};

export default Loading;